import React from 'react'
import css from './styles.module.scss'
import HeroTitle from 'components/typo/HeroTitle'
import Text from 'components/typo/Text'
import Layout from 'components/shared/Layout'
import BenefitRow from 'components/shared/BenefitRow'

const FeaturesGrid = ({ upperTitle, title, description, benefits}) => {
  return (
    <Layout type="wrapper">
      <div className={css.wrapper}>
        <div className={css.header}>
          <Text className={css.upperTitle}>{upperTitle}</Text>
          <HeroTitle className={css.heroTitle} tag="h2">
            {title}
          </HeroTitle>
          <Text className={css.description}>{description}</Text>
        </div>
        {benefits && (
          <div className={css.benefits}>
            {benefits.map((benefit) => (
              <BenefitRow key={benefit.id} {...benefit} />
            ))}
          </div>
        )}
      </div>
    </Layout>
  )
}

export default FeaturesGrid
